export default populateExternalModuleImports;

function populateExternalModuleImports(bundle) {
	bundle.modules.forEach(function (mod) {
		mod.imports.forEach(function (x) {
			var externalModule = x.module;

			if (!externalModule.isExternal) {
				return;
			}

			x.specifiers.forEach(function (s) {
				if (s.isDefault) {
					externalModule.needsDefault = true;
				} else {
					externalModule.needsNamed = true;
				}
			});
		});
	});
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/combine/populateExternalModuleImports.js.01-babel.map